module.exports = __webpack_public_path__ + "images/柏纳s长图_04-2.jpg?v=684ffb84";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_04-2.jpg
 ** module id = 160
 ** module chunks = 1 2
 **/